var map = {
	"./adobe-logo-tab.png": "0FDv",
	"./adobe.svg": "YCA1",
	"./conde-nast-white.svg": "LN9F",
	"./conde-nast.svg": "t7N1",
	"./dow-jones-white.svg": "NnZ/",
	"./dow-jones.svg": "dlhv",
	"./edelman-white.svg": "S/Xj",
	"./edelman.svg": "DSO0",
	"./nat-geo-white.svg": "eYHE",
	"./nat-geo.svg": "Kg5H",
	"./nbc-universal-white.svg": "M1MC",
	"./nbc-universal.svg": "xRog",
	"./revolt-white.svg": "7fM3",
	"./revolt.svg": "0fDh",
	"./spotify-white.svg": "INxt",
	"./spotify.svg": "FLp1",
	"./usa-today-white.svg": "xOLk",
	"./usa-today.svg": "3ShR",
	"./wired-white.svg": "6ZPc",
	"./wired.svg": "AN/l"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Wd1M";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos ^\.\/.*$
// module id = Wd1M
// module chunks = 1